'use client'

import { useAtomValue } from 'jotai'
import { ListRowImage } from '@/src/components/ui/list-row'
import {
  isCompleteAtom,
  routeAtom,
  routeMachineSnapshotAtom,
} from '@/src/stores/route-machine/atoms'
import { ChainImg } from '../../ui/chain-img'
import { BasicStepRow } from './basic-step-row'

const ChainIcon = () => {
  const route = useAtomValue(routeAtom)
  const snapshot = useAtomValue(routeMachineSnapshotAtom)

  const refundInfo = snapshot.context.refundInfo

  if (refundInfo) {
    return (
      <ChainImg
        chainId={refundInfo.chainID}
        chainImg={refundInfo.chainImg}
        chainName={refundInfo.chainName}
      />
    )
  }

  if (!route) {
    return null
  }

  return (
    <ChainImg
      chainId={route.destinationChain.chain_id}
      chainImg={route.destinationChain.chain_img}
      chainName={route.destinationChain.chain_name}
    />
  )
}

const Title = () => {
  const route = useAtomValue(routeAtom)
  const snapshot = useAtomValue(routeMachineSnapshotAtom)

  const refundInfo = snapshot.context.refundInfo
  const destinationChainName =
    refundInfo?.chainName || route?.destinationChain.chain_name

  const destinationTicker =
    refundInfo?.ticker || route?.OutputAssetMetadata.ticker
  const destinationAssetImg =
    refundInfo?.assetImg || route?.OutputAssetMetadata.logo_img_url

  if (!route) {
    return null
  }

  return (
    <div className='flex gap-3 items-center'>
      <ListRowImage
        src={destinationAssetImg}
        width={40}
        height={40}
        className='size-10 rounded-full'
        unoptimized
      />
      <div className='flex flex-col text-primary font-semibold items-baseline'>
        {destinationTicker}{' '}
        <span
          data-testid='to-chain-name'
          className='font-normal text-sm leading-6 text-secondary'
        >
          on {destinationChainName}
        </span>
      </div>
    </div>
  )
}

export const RouteToChain = () => {
  const route = useAtomValue(routeAtom)
  const isComplete = useAtomValue(isCompleteAtom)

  if (!route) {
    return null
  }

  return (
    <BasicStepRow
      isSuccess={isComplete}
      title={<Title />}
      icon={<ChainIcon />}
      hideAfterLine
    />
  )
}
